export const DEFAULT_ROWS_PAGINATION = [5, 10, 25];

export const DEFAULT_PAGINATION_OPTIONS = {
  offset: 0,
  limit: DEFAULT_ROWS_PAGINATION[0],
};
